import { AvatarCreator } from '@readyplayerme/react-avatar-creator'

const style = {
  width: '100%',
  height: '100vh',
}

const Avatar = ({ handleAvatar, avatarId, token }) => {
  const config = {
    clearCache: true, // Clear cache if needed
    bodyType: 'fullbody', // Choose between 'fullbody' or 'halfbody'
    quickStart: false, // Disable quick start to allow full customization
    language: 'en', // Language for the avatar editor UI
    avatarId: avatarId,
    token: token,
  }

  // Handle avatar export
  const handleOnAvatarExported = (event) => {
    handleAvatar(event.data) // Set the exported avatar URL
  }

  return (
    <>
      <AvatarCreator
        className="avatar-creator-container"
        subdomain={process.env.REACT_APP_READYPLAYER_SUBDOMAIN}
        config={config}
        style={style}
        onAvatarExported={handleOnAvatarExported}
      />
    </>
  )
}

export default Avatar
